import React, { useEffect, useRef, useState } from "react";
import { Box } from "@material-ui/core";
import apiUtil from "../../api/apiUtil";
import CustomSearchBar from "../../components/CustomSearchBar/CustomSearchBar";
import Table from "../../components/Table/Table";
import "./branch.css";
import add from "../../images/icons/add.png";
import close from "../../images/icons/close.png";
import edit from "../../images/icons/edit.png";
import delete_icon from "../../images/icons/delete.png";
import CustomButton from "../../components/CustomButton/custombutton";
import * as Yup from "yup";
import { Form, Formik } from "formik";
import CustomInput from "../../components/CustomInput/CustomInput";
import api from "../../api/api";
import getToken from "../getToken";

const Branch = () => {
  const [showAddBranch, setShowAddBranch] = useState(false);
  const [showEditBranch, setShowEditBranch] = useState(false);
  const refBranchTable = useRef();
  const refPreviewBranchFiles = useRef(false);
  const refBranchListForm = useRef(null);
  const [detailBranch, setDetailBranch] = useState(null);
  const [keyword, setKeyword] = useState("");
  let brandId = localStorage.getItem("brandId");

  const clickAddBranch = (e) => {
    e.stopPropagation();
    if (showEditBranch) {
      setShowEditBranch(false);
      setTimeout(() => setShowAddBranch(true), 100);
    } else {
      setShowAddBranch(true);
    }
  };
  const clickBtnClose = () => {
    setShowAddBranch(false);
    setShowEditBranch(false);
  };
  const clickEdit = (rowData) => {
    setDetailBranch({
      id: rowData.id,
      brandId: brandId,
      name: rowData.branchName,
      phone: rowData.phone,
      email: rowData.email,
      address: rowData.address,
    });
    setShowEditBranch(true);
  };
  const initialValues = {
    name: "",
    phone: "",
    email: "",
    address: "",
  };

  const handleDelete = (rowData) => {
    console.log(rowData);
    if (window.confirm("Are you sure you want to delete this Branch?")) {
      api
        .delete(`Admin/DeleteBranch?branchId=${rowData.id}`, getToken())
        .then((result) => {
          apiUtil.parseResult(
            result,
            (response) => {
              if (response.data.code === 401) {
                alert(response.data.message);
                localStorage.removeItem("user");
                window.location.href = "/login";
              } else if (response.data.statusCode === 200) {
                alert("Branch deleted successfully!");
                retrievebranchList();
              } else {
                alert(response.data.message);
              }
            },
            (error) => {
              alert(error);
            }
          );
        });
    }

  };


  const AddBranchFormValidation = Yup.object().shape({
    name: Yup.string().nullable().required("Please enter the name."),
    phone: Yup.string()
      .required("Please enter the phone number.")
      .test(
        "phone",
        "Please enter format phone number. For example, 09xxxxxxxxx (or) 018xxxxxx.",
        (val) => /^\d{2,3}\d{7,9}$/g.test(val)
      ),
    address: Yup.string().required("Please enter the address."),

  });

  const [branchList, setBranchList] = useState({
    isLoading: false,
    grouping: false,
    limit: apiUtil.getDefaultPageSize(),
    data: [],
    total: 0,
    page: 1,
  });

  const [param, setParam] = useState({
    keyword: "",
    rowLimit: 10,
    currentPage: 1,
    sortBy: "",
    isDesc: true,
    brandId: brandId,
  });

  const retrievebranchList = (value = param) => {
    value.keyword = keyword || "";
    setBranchList({
      ...branchList,
      isLoading: false,
    });

    api.post("Admin/GetBranchList", value, getToken())
      .then((result) => {
        apiUtil.parseResult(
          result,
          (response) => {
            if (response.data.code === 401) {
              alert(response.data.message);
              localStorage.removeItem("user");
              window.location.href = "/login";
            }
            if (response.data.code === 200) {
              if (response.data.data.data != null) {
                setBranchList({
                  isLoading: false,
                  limit: response.data.data.rowLimit,
                  data:
                    response.data.data.data &&
                      response.data.data.data.length > 0
                      ? response.data.data.data
                      : [],
                  total: response.data.data.data.totalRecords,
                  page: response.data.data.paging,
                });
              }
              else {
                setBranchList({
                  isLoading: false,
                  grouping: false,
                  limit: apiUtil.getDefaultPageSize(),
                  data: [],
                  total: 0,
                  page: 0,
                });
              }
            }
          },
          (error, type) => {
            console.log(error);
          }
        );
      });
  };

  const handleSubmitForm = (values, actions) => {
    const payload = {
      brandId: brandId,
      branchName: values.name,
      phone: values.phone,
      email: values.email,
      address: values.address,
    };

    console.log(payload);

    api.post("Admin/CreateBranch", payload, getToken()).then((result) =>
      apiUtil.parseResult(
        result,
        (response) => {
          if (response.data.code === 401) {
            alert(response.data.message);
            localStorage.removeItem("user");
            window.location.href = "/login";
          } else if (response.data.code === 200) {
            alert("Branch saved successfully!!");

            // reset the inputs and clear values
            actions.resetForm();
            values = {};
            setShowAddBranch(false);
            for (let i = 0; i < refBranchListForm.current.length - 2; i++) {
              refBranchListForm.current[i].value = "";
            }

            refPreviewBranchFiles.current = false;
            //refresh menu list
            retrievebranchList(param);
          } else {
            alert(response.data.message);
          }
        },
        (error) => {
          console.log(error);
        }
      )
    );

    actions.setSubmitting(false);
  };

  const editBranchSubmit = (values, actions) => {
    const payload = {
      id: values.id,
      brandId: brandId,
      branchName: values.name,
      phone: values.phone,
      email: values.email,
      address: values.address,
    };
    console.log(payload);
    api.post("Admin/UpdateBranch", payload, getToken()).then((result) =>
      apiUtil.parseResult(
        result,
        (response) => {
          if (response.data.code === 401) {
            alert(response.data.message);
            localStorage.removeItem("user");
            window.location.href = "/login";
          } else if (response.data.statusCode === 200) {
            alert("Branch updated successfully!!");
            setShowEditBranch(false);
            retrievebranchList(param);
          } else {
            alert(response.data.message);
          }
        },
        (error) => {
          console.log(error);
        }
      )
    );

    actions.setSubmitting(false);
  };


  useEffect(() => {
    retrievebranchList();
  }, [param]);

  return (

    <>
      {(showAddBranch || showEditBranch) && (
        <>
          <div className="Actions space_between">
            <h6 className="title_text mt-2">Branch</h6>
            <button className="btn btnClose" onClick={clickBtnClose}>
              <img src={close} className="imgClose" alt="imgClose" />
            </button>
          </div>

          <Formik
            initialValues={showEditBranch ? detailBranch : initialValues}

            enableReinitialize={true}
            validateOnBlur={false}
            validationSchema={AddBranchFormValidation}
            onSubmit={(values, actions) => {
              showEditBranch
                ? editBranchSubmit(values, actions)
                : handleSubmitForm(values, actions);
            }}
          >
            {({ values, errors, touched, setFieldValue }) => (
              <Form
                ref={refBranchListForm}
                className="row form-container add-branch-form"
              >
                <div className="col-6 mt-2">
                  <CustomInput
                    name="name"
                    type="text"
                    label="Branch Name"
                    customclass="input_wrapper"
                    hideicon="true"
                    placeholder="Enter Branch Name"
                  />
                </div>
                <div className="col-6 mt-2">
                  <CustomInput
                    name="phone"
                    type="phone"
                    label="Phone Number"
                    customclass="input_wrapper"
                    hideicon="true"
                    placeholder="09-"
                  />
                </div>
                <div className="col-6 mt-2">
                  <CustomInput
                    name="email"
                    type="email"
                    label="Email"
                    customclass="input_wrapper"
                    hideicon="true"
                    placeholder="example@gmail.com"
                  />
                </div>

                <div className="col-12 mt-2">
                  <CustomInput
                    name="address"
                    label="Address"
                    textarea="true"
                  />
                </div>
                <div className="form-group mt-4">
                  <div className="Actions justify-content-end">
                    <button
                      type="button"
                      className="button btnCancel"
                      onClick={clickBtnClose}
                    >
                      Cancel
                    </button>
                    <button type="submit" className="button btnSave">
                      {showAddBranch ? "Create" : "Update"}
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </>
      )}

      <div className="Actions space_between">
        <h6 className="title_text mt-2">Branch</h6>
        <div className="d-flex justify-content-end gap-16 align-items-center">
          {/* <CustomFilter /> */}
          <CustomSearchBar
            value={keyword}
            setValue={setKeyword}
            onSearch={() => retrievebranchList()}
          />
          {!showAddBranch && (
            <CustomButton
              icon={add}
              text="Add Branch"
              addIcon={true}
              className="btnAdd"
              onClick={(e) => clickAddBranch(e)}
            />
          )}
        </div>
      </div>

      <div className="table_container branch_table">
        <Table
          ref={refBranchTable}
          maxBodyHeight={branchList.limit * 100}
          isLoading={branchList.isLoading}
          grouping={branchList.grouping}
          limit={branchList.limit}
          page={branchList.page}
          total={branchList.total}
          data={branchList.data}
          onPageChange={(page) => {
            setParam({
              ...param,
              currentPage: page,
            });
            retrievebranchList(param);
          }}
          columns={[
            {
              title: "No",
              render: (row) => {
                const startingIndex = (branchList.page - 1) * branchList.limit + 1;
                return startingIndex + row.tableData.index;
              },
              width: "80px",
              align: "center",
            },

            {
              title: "Name",
              render: (row) => {
                if (row.branchName == null || row.branchName == "") {
                  return "Unknown";
                }
                return row.branchName;
              },
              width: "100px",
            },
            {
              title: "Phone Number",
              field: "phone",
              width: "120px",
            },
            {
              title: "Email",
              field: "email",
              width: "100px",
            },
            {
              title: "Address",
              field: "address",
              width: "120px",
            },
            {
              title: "Edit",
              render: (row) => {
                return (
                  <Box
                    className=" cursor-pointer"
                    onClick={(e) => clickEdit(row)}
                  >
                    <img src={edit} alt="" className="imgIcon" />
                  </Box>
                );
              },
              align: "center",
              sorting: false,
              width: "80px",
            },
            {
              title: "Delete",
              render: (row) => {
                return (
                  <Box
                    style={{ cursor: "pointer" }}
                    onClick={() => handleDelete(row)}
                  >
                    <img src={delete_icon} alt="" className="imgIcon" />
                  </Box>
                );
              },
              align: "center",
              sorting: false,
              width: "80px",
            },
          ]}
        />
      </div>
    </>

  );
};
export default Branch;
